export const SkullIcon = () => {
  return (
    <i className='material-symbols-skull-outline text-xl m-[2px] bg-[var(--mui-palette-error-main)]' />
  );
};
